var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavFlash = function SvgNavFlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NavFlash_svg__flash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "NavFlash_svg__Vector",
    d: "M5.075 11.0667H7.65V17.0667C7.65 18.4667 8.40833 18.75 9.33333 17.7L15.6417 10.5333C16.4167 9.65833 16.0917 8.93333 14.9167 8.93333H12.3417V2.93333C12.3417 1.53333 11.5833 1.25 10.6583 2.3L4.35 9.46667C3.58333 10.35 3.90833 11.0667 5.075 11.0667Z",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "NavFlash_svg__Vector_2",
    opacity: 0
  }))));
};
export default SvgNavFlash;